'use client';

import Link from "next/link";
import { usePathname } from "next/navigation";
import { FaExclamationTriangle } from "react-icons/fa";
import SiteLayout from "@/layout/Layout";

export default function NotFound() {
  const pathname = usePathname();
  const isPT = pathname?.startsWith('/pt');
  const locale = isPT ? 'pt' : 'en';

  return (
    <SiteLayout locale={locale}>
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-[#1B475D] px-4 py-12 text-center">
        <FaExclamationTriangle className="text-[#FAD564]" size={50} />
        <h1 className="text-2xl sm:text-3xl md:text-4xl text-[#1B475D] font-bold mb-8">
          {isPT ? "Página não encontrada" : "Page Not Found"}
        </h1>
        <p className="text-base text-[#1B475D]/80 max-w-md">
          {isPT
            ? "Desculpe, a página que você procura não existe ou foi movida."
            : "Sorry, the page you’re looking for doesn’t exist or has been moved."}
        </p>
        <Link
          href={`/${locale}`}
          className="mt-8 inline-block bg-[#8EBD9D] hover:bg-[#77A885] text-[#1B475D] font-semibold px-6 py-2 rounded-full transition"
        >
          {isPT ? "Voltar para o início" : "Go Back Home"}
        </Link>
      </div>
    </SiteLayout>
  );
}
